class Api {
  static async doRequest(url, params) {
    console.log(url);
    const response = await fetch(url, params);

    if (response.ok) {
      return response.json();
    }

    return Promise.reject(response);
  }

  static get(url) {
    const postParams = {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
    };

    return Api.doRequest(url, postParams);
  }

  static post(url, params = {}) {
    const postParams = {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *client
      ...params,
    };

    return Api.doRequest(url, postParams);
  }

  static put() {
    // todo
  }

  static delete() {
    // todo
  }
}

export default Api;
